import { createWebHistory, createRouter } from "vue-router";

  const routes =  [
  {
    path: "/",
    component: () => import('../components/LoginView.vue'),
  },
  {
    path: "/login",
    component: () => import('../components/LoginView.vue'),
  },
  {
    path: "/dashboard",
    component: () => import('../components/DashboardView.vue'),
  },
  {
    path: "/settings",
    component: () => import('../components/SettingsPanel.vue'),
  },
  {
    path: "/user",
    component: () => import('../components/UserPanel.vue'),
  },
  {
    path: "/add/injection",
    component: () => import('../components/AddInjectionForm.vue'),
  },
  {
    path: "/list/injection",
    component: () => import('../components/InjectionTable.vue'),
  },
  {
    path: "/add/waist",
    component: () => import('../components/AddWaistForm.vue'),
  },
  {
    path: "/list/waist",
    component: () => import('../components/WaistTable.vue'),
  },
  {
    path: "/add/weight",
    component: () => import('../components/AddWeightForm.vue'),
  },
  {
    path: "/list/weight",
    component: () => import('../components/WeightTable.vue'),
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: routes,
  linkActiveClass: 'active'
})

export default router;